"use strict";
// IMPORTANT: changes in this file will require a DB migration!
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_STEP_DESCRIPTIONS = exports.FundingVerificationApproval = exports.FundingVerificationReport = exports.CalcAgent = exports.GenerateLoanTapes = exports.UserDataValidation = exports.MAX_ERRORS_PER_ENTRY = void 0;
exports.MAX_ERRORS_PER_ENTRY = 500;
var UserDataValidation;
(function (UserDataValidation) {
    // Order matters! This is the order in which the steps occur.
    UserDataValidation.STEP_DESCRIPTIONS = ['Validate input data'];
})(UserDataValidation = exports.UserDataValidation || (exports.UserDataValidation = {}));
var GenerateLoanTapes;
(function (GenerateLoanTapes) {
    // Order matters! This is the order in which the steps occur.
    GenerateLoanTapes.STEP_DESCRIPTIONS = ['Generate loan tapes'];
})(GenerateLoanTapes = exports.GenerateLoanTapes || (exports.GenerateLoanTapes = {}));
var CalcAgent;
(function (CalcAgent) {
    // Order matters! This is the order in which the steps occur.
    CalcAgent.STEP_DESCRIPTIONS = [
        'Evaluate eligibility criteria',
        'Evaluate concentration limit criteria',
        'Compute receivable advance rates',
    ];
})(CalcAgent = exports.CalcAgent || (exports.CalcAgent = {}));
var FundingVerificationReport;
(function (FundingVerificationReport) {
    // Order matters! This is the order in which the steps occur.
    FundingVerificationReport.STEP_DESCRIPTIONS = ['Finalize output for review'];
})(FundingVerificationReport = exports.FundingVerificationReport || (exports.FundingVerificationReport = {}));
var FundingVerificationApproval;
(function (FundingVerificationApproval) {
    // Order matters! This is the order in which the steps occur.
    FundingVerificationApproval.STEP_DESCRIPTIONS = ['Approve or deny funding request'];
})(FundingVerificationApproval = exports.FundingVerificationApproval || (exports.FundingVerificationApproval = {}));
exports.ALL_STEP_DESCRIPTIONS = [
    ...UserDataValidation.STEP_DESCRIPTIONS,
    ...GenerateLoanTapes.STEP_DESCRIPTIONS,
    ...CalcAgent.STEP_DESCRIPTIONS,
    ...FundingVerificationReport.STEP_DESCRIPTIONS,
    ...FundingVerificationApproval.STEP_DESCRIPTIONS,
];
//# sourceMappingURL=Pipeline.js.map